// extracted by mini-css-extract-plugin
export default {"imageContainer":"ImageUploader_imageContainer__PHHCA","uploadImage":"ImageUploader_uploadImage__xUDXy","closeBtn":"ImageUploader_closeBtn__rZ5dJ"};